<template>
    <div class="container">
        <MenuAdmin />
        <FullScreenLoader v-if="loading" />
        <div v-if="!loading">
            <!-- <PreLiveShop v-if="active === 1" :date="fecha" :urlImgPC="urlImgPrePC" :urlImgMO="urlImgPreMO" /> -->
            <LiveShop v-if="active === 3" />
        </div>

    </div>
</template>

<script>
import LiveShop from '../components/LiveShop.vue';
import MenuAdmin from '../components/MenuAdmin.vue';
import PreLiveShop from '../components/PreLiveShop.vue';
import FullScreenLoader from '../components/FullScreenLoader.vue';
import fire from '../fire';
export default {
    name: 'AdminLiveshopDebug',
    components: {
        MenuAdmin,
        LiveShop,
        PreLiveShop,
        FullScreenLoader
    },
    data() {
        return {
            active: 3,
            fecha: new Date("2023/04/13 20:00:00"),
            urlImgPrePC: '',
            urlImgPreMO: '',
            loading: true,
        }
    },
    mounted() {
        this.loading = true;
        let ref = this;
        const itemsRef = fire.database().ref("config");
        itemsRef.on("value", snapshot => {
            let data = snapshot.val();
            ref.fecha = data.fecha;
            ref.urlImgPostPC = data.urlImgPostPC;
            ref.urlImgPostMO = data.urlImgPostMO;
            ref.urlImgPrePC = data.urlImgPrePC;
            ref.urlImgPreMO = data.urlImgPreMO;
            //ref.active = data.active;
            this.loading = false
        });
    },
}
</script>

<style lang="scss" scoped></style>